import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useProjectStore = create(persist(
  (set, get) => ({
    projectDataStore: {
      customerData: {
        company: {
          id: '',
          name: '',
          sector: ''
        },
        focalPoint: '',
        focalPointPosition: '',
        focalPointEmail: '',
        businessDescritive: ''
      },
      projectData: {
        id: '',
        title: '',
        type: '',
        startDate: '',
        endDate: '',
        goal: '',
        businessContext: '',
        targetPublic: ''
      },
      impact: {
        expectedResults: '',
        impactedBusinessIndicators: [],
        deliverables: []
      }
    },
    projectSummary: '', 
  
    // Updates nos dados de cliente
    updateCompany: (companyItem) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        customerData: {
          ...state.projectDataStore.customerData,
          company: {
            id: companyItem.id,
            name: companyItem.name,
            sector: companyItem.sector
          }
        }
      }
    })),

    updateFocalPoint: (focalPoint) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        customerData: {
          ...state.projectDataStore.customerData,
          focalPoint
        }
      }
    })),

    updateFocalPointPosition: (focalPointPosition) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        customerData: {
          ...state.projectDataStore.customerData,
          focalPointPosition
        }
      }
    })),

    updateFocalPointEmail: (focalPointEmail) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        customerData: {
          ...state.projectDataStore.customerData,
          focalPointEmail
        }
      }
    })),

    updateBusinessDescritive: (businessDescritive) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        customerData: {
          ...state.projectDataStore.customerData,
          businessDescritive
        }
      }
    })),

    // Updates nos dados de projeto
    updateProjectTitle: (title) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        projectData: {
          ...state.projectDataStore.projectData,
          title
        }
      }
    })),

    updateProjectType: (type) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        projectData: {
          ...state.projectDataStore.projectData,
          type
        }
      }
    })),

    updateStartDate: (startDate) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        projectData: {
          ...state.projectDataStore.projectData,
          startDate
        }
      }
    })),

    updateEndDate: (endDate) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        projectData: {
          ...state.projectDataStore.projectData,
          endDate
        }
      }
    })),

    updateGoal: (goal) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        projectData: {
          ...state.projectDataStore.projectData,
          goal
        }
      }
    })),

    updateBusinessContext: (businessContext) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        projectData: {
          ...state.projectDataStore.projectData,
          businessContext
        }
      }
    })),

    updateTargetPublic: (targetPublic) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        projectData: {
          ...state.projectDataStore.projectData,
          targetPublic
        }
      }
    })),

    // Update nos dados de impacto
    updateExpectedResults: (expectedResults) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        impact: {
          ...state.projectDataStore.impact,
          expectedResults
        }
      }
    })),

    updateImpactedBusinessIndicators: (impactedBusinessIndicators) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        impact: {
          ...state.projectDataStore.impact,
          impactedBusinessIndicators
        }
      }
    })),

    updateDeliverables: (deliverables) => set((state) => ({
      projectDataStore: {
        ...state.projectDataStore,
        impact: {
          ...state.projectDataStore.impact,
          deliverables
        }
      }
    })),

    // Updates gerais
    setProjectData: (newData) => set((state) => ({
      projectDataStore: { ...state.projectDataStore, ...newData }
    })),

    setProjectSummary: (resume) => set({ projectSummary: resume }),

    // Validação
    isFormValid: () => {
      const state = get();
      const { customerData, projectData } = state.projectDataStore;
      
      return (
        customerData.company.id !== '' &&
        customerData.company.name !== '' &&
        // customerData.company.sector !== '' &&
        customerData.businessDescritive &&
        projectData.title &&
        projectData.type &&
        projectData.startDate &&
        projectData.goal &&
        projectData.targetPublic
      );
    },

    // Reset
    resetProject: () => set({
      projectDataStore: {
        customerData: {
          company: {
            id: '',
            name: '',
            sector: ''
          },
          focalPoint: '',
          focalPointPosition: '',
          focalPointEmail: '',
          businessDescritive: ''
        },
        projectData: {
          title: '',
          type: '',
          startDate: '',
          endDate: '',
          goal: '',
          businessContext: '',
          targetPublic: ''
        },
        impact: {
          expectedResults: '',
          impactedBusinessIndicators: [],
          deliverables: []
        }
      },
      projectSummary: ''
    })
  }),
  { name: 'project-store' }
));

export default useProjectStore;